// Configuración de API
const API_CONFIG = {
  // URL base para desarrollo local
  LOCAL_BASE_URL: 'http://localhost:8080/datos',
  
  // URL base para producción
  PRODUCTION_BASE_URL: 'https://mailing.orangemation.com',
  
  // Determinar si estamos en desarrollo o producción basado en la URL actual
  isDevelopment: function() {
    if (typeof window === 'undefined') return false;
    return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  },
  
  // Obtener la URL base correcta
  getBaseURL: function() {
    return this.isDevelopment() ? this.LOCAL_BASE_URL : this.PRODUCTION_BASE_URL;
  },
  
  // Obtener la URL completa de la API
  getApiURL: function(endpoint = '') {
    const baseURL = this.getBaseURL();
    const apiPath = '/api/';
    return `${baseURL}${apiPath}${endpoint}`;
  }
};

export default API_CONFIG;

// Funciones de utilidad para construir URLs de API
export const buildApiUrl = (endpoint) => {
  return API_CONFIG.getApiURL(endpoint);
};

export const buildFullUrl = (path) => {
  return `${API_CONFIG.getBaseURL()}${path}`;
};